import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

/**
 * Connect to WebSocket server using cookie-based authentication.
 * The server extracts the access token from HttpOnly cookies sent with the
 * WebSocket handshake (withCredentials: true).
 */
export function connectSocket(): Socket {
  if (socket?.connected) {
    return socket;
  }

  socket = io(window.location.origin, {
    // Cookie-based auth: server reads access_token from HttpOnly cookie
    // No need to pass token explicitly - cookies are sent with handshake
    withCredentials: true,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('Socket connected:', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error.message);
  });

  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket(): Socket | null {
  return socket;
}

export function joinSession(sessionId: string): void {
  socket?.emit('join:session', { sessionId });
}

export function leaveSession(sessionId: string): void {
  socket?.emit('leave:session', { sessionId });
}

export function joinCampus(campusId: string): void {
  socket?.emit('join:campus', { campusId });
}

export function leaveCampus(campusId: string): void {
  socket?.emit('leave:campus', { campusId });
}
